/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * YOU ARE FREE TO MODIFY IT AS NEEDED.
 * * The only thing you should not modify is this very comment.
 * * The list below is used to generate new hooks based on their name.
 * * When new hook name is not found in the list, it will be generated
 * * and appended at the end of the file.
 * *
 * * Previously generated hooks (DO NOT MODIFY): [usePostSetup]
 */

import { PlaySetup } from '../types/CodegenSetupTypes';
import { useMutation } from '@tanstack/react-query';
import { useNotificationsStore } from 'stores/NotificationsStore';
import { useStores } from 'index';

export const usePostSetup = () => {
  const codegenSetupService = useStores().codegenSetupService;
  const { addToast } = useNotificationsStore();

  return useMutation({
    mutationFn: ({ requestBody }: { requestBody: PlaySetup }) => {
      return codegenSetupService.postSetup(requestBody);
    },
    onSuccess: () => addToast('Success', 'Saved the order of players.', 'success'),
    onError: () => addToast('Error', 'Something went wrong, please try again.', 'success'),
  });
};
